import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';

import { trackBuyerApplicationQuestionView } from '../utils';

export const EMAIL_INPUT_NAME =
  'buyer_profile_attributes.user_attributes.email';
export const PASSWORD_INPUT_NAME =
  'buyer_profile_attributes.user_attributes.password';

export default function ExitModal({
  onSignupClick,
  onCloseClick,
  onForceCloseClick,
  formErrors,
  formState,
  onChange,
  displayErrors,
  programName,
  breederSlug
}) {
  const {
    [EMAIL_INPUT_NAME]: emailErrors = [],
    [PASSWORD_INPUT_NAME]: passwordErrors = []
  } = formErrors;

  useEffect(() => {
    trackBuyerApplicationQuestionView('Exit without saving?', {
      programName,
      breederSlug
    });
  }, []);

  return (
    <MiniOverlayModal onCloseClick={onCloseClick}>
      <div className="pv16-sm pv8 ph20-sm ph8">
        <div className="tc mb10">
          <h5 className="red mb2">Exit without saving?</h5>
          <p>Create an account to save your progress.</p>
        </div>
        <form onSubmit={onSignupClick}>
          <label className="mb5 db">
            <p className="mb1 f2 fw-medium">Email Address</p>
            <ErrorWrapper errors={emailErrors} isShown={displayErrors}>
              <input
                type="email"
                autoComplete="username"
                placeholder="jane@highpeaksfarm.com"
                name={EMAIL_INPUT_NAME}
                onChange={onChange}
                className="w-100 pv2 ph2 br2 ba b--moon-gray"
                value={get(formState, EMAIL_INPUT_NAME) || ''}
              />
            </ErrorWrapper>
          </label>

          <label className="mb10 db">
            <p className="mb1 f2 fw-medium">Password</p>
            <ErrorWrapper errors={passwordErrors} isShown={displayErrors}>
              <input
                type="password"
                placeholder="6+ characters"
                name={PASSWORD_INPUT_NAME}
                onChange={onChange}
                className="w-100 pv2 ph2 br2 ba b--moon-gray"
                value={get(formState, PASSWORD_INPUT_NAME) || ''}
              />
            </ErrorWrapper>
          </label>

          <div className="row slim-gutters">
            <div className="col-sm">
              <button
                type="submit"
                className="button button--primary button--large pv3 fw-medium w-100 nowrap mb2"
                disabled={Boolean(emailErrors.length || passwordErrors.length)}
              >
                Sign up
              </button>
            </div>
            <div className="col-sm-auto">
              <button
                type="button"
                className="button button--red button--large pv3 fw-medium w-100 nowrap mb2"
                onClick={onForceCloseClick}
              >
                Exit without saving
              </button>
            </div>
          </div>
        </form>
      </div>
    </MiniOverlayModal>
  );
}

ExitModal.propTypes = {
  onSignupClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onForceCloseClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formErrors: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  displayErrors: PropTypes.bool.isRequired,
  programName: PropTypes.string,
  breederSlug: PropTypes.string
};

ExitModal.defaultProps = {
  breederSlug: null,
  programName: null
};
